import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=44ee87ec&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=44ee87ec&prod&lang=less"
import style1 from "./PageHeader.vue?vue&type=style&index=1&id=44ee87ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ee87ec",
  null
  
)

export default component.exports